import React, { useState, useEffect, forwardRef } from "react";

import MaterialTable from "material-table";
import Chip from "@material-ui/core/Chip";
// import Avatar from "@material-ui/core/Avatar";

import { request, handleErrors } from "./../../services/helpers";

import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

import SectionHeader from "../../components/SectionHeader/SectionHeader";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export default function MaterialTableDemo() {
  const [loading, setLoading] = useState(false);
  const [logData, setLogData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await request.get("/activityLog");
        setLogData(res.data);
      } catch (err) {
        // const membershipsfetchError = handleErrors(err) || err;
        // setFetchError(membershipsfetchError);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const actionChipDesigner = (action) => {
    switch (action) {
      case "DELETE": {
        return (
          <Chip className="bg-red-600 text-white  w-full" label="TERMINATED" />
        );
      }
      case "CREATE": {
        return (
          <Chip className="bg-green-600 text-white  w-full" label="CREATED" />
        );
      }
      case "UPDATE": {
        return (
          <Chip className="bg-blue-600 text-white  w-full" label="UPDATED" />
        );
      }
      case "FETCH": {
        return (
          <Chip className="bg-gray-600 text-white  w-full" label="FETCHED" />
        );
      }
      default:
        return (
          <Chip className="bg-gray-700 text-white w-full" label={action} />
        );
    }
  };
  return (
    <div className="flex flex-1 flex-col justify-center mt-10">
      <SectionHeader
        path={["Invoices", "Adhoc Invoice Generation"]}
        title={"Activity Logs"}
      />
      <div className="px-8 lg:px-32 py-4 bg-white shadow-lg">
        <MaterialTable
          // style={{ padding: 20 }}
          icons={tableIcons}
          title="Logs"
          columns={[
            {
              title: "User",
              field: "username",
              render: (rowData) => (
                <div className="flex flex-row justify-center items-center">
                  <div className="flex w-1/2 items-center justify-center">
                    <img
                      src={rowData.profilePicture}
                      alt="avatar"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 20,
                        minWidth: 40,
                        minHeight: 40,
                      }}
                    />
                  </div>
                  <label className="w-1/2 text-left">
                    {rowData.username}
                  </label>
                </div>
              ),
              align: "center",
            },
            // { title: "Name", field: "username" },
            { title: "Date", field: "date", type: "date", align: "center" },
            {
              title: "Action",
              field: "action",
              render: (rowData) => actionChipDesigner(rowData.action),
              align: "center",
            },
            { title: "Resource", field: "resource" },
            { title: "Membership Name", field: "membershipName" },
          ]}
          // data={[...tableData]}
          data={logData}
          options={{
            sorting: true,
            pageSize: 10,
            pageSizeOptions: [5, 10],
            //   paginationType: "stepped",
            draggable: false,
            columnsButton: true,
            headerStyle: {
              backgroundColor: "#FAFAFA",
              zIndex: 0,
              color: "#212121",
              fontWeight: "bold",
              //   textAlign: "center",
            },
          }}
          isLoading={loading}
        />
      </div>
    </div>
  );
}
